import { useState } from "react";
import Ssl from "./view/ssl/Ssl";




function ToolsView(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
    }


    if(props.mainView.viewSelected == 'ssl')
    {
        document.title ="Certyfikaty SSL";
        return (
            <div className="econtent ">
                  <Ssl  userData={props.userData}  mainView={props.mainView} keyListener={props.keyListener}   />
            </div>
        )
    }


        return (
        <div className="econtent ">
             ToolsView - no selected menu position
        </div>
    );
}


export default ToolsView ;
